export default __webpack_public_path__ + "static/media/A1.4d6e74a1.png";